import { IGetHospitalReportsAction } from './hospitalReport.interface';
import { HospitalReportTypes } from './hospitalReport.type';

export const getHospitalReports = (hospital_id?: string): IGetHospitalReportsAction => ({
  type: HospitalReportTypes.GET_HOSPITAL_REPORTS,
  hospital_id,
});
